import React from "react";
import { createMarkup } from "../../../utils/helper";

const ArticleContent = (props: { rawContent: string }) => {
  const { rawContent } = props;
  return (
    <div className="sun-editor-editable article_content font-light " dangerouslySetInnerHTML={createMarkup(rawContent)}></div>
  );
};

export default ArticleContent;